import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientAPI } from "./axiosAnstance";
import axios from "axios";
import { SERVER_URL } from "../../../serverConfig";
import { getAuthHeader } from "../../../jwt/config";
import fileDownload from "js-file-download";

// --- THUNKS (LOGIQUE API) ---

// 1. Listes de paramètres
export const listBrancheAPI = createAsyncThunk(
  "bourse/listBranche",
  async () => {
    const response = await clientAPI.get("/api/bourse/getBranche");
    return response.data;
  }
);

export const listAnneeAPI = createAsyncThunk(
  "bourse/listAnnee",
  async () => {
    const response = await clientAPI.get("/api/bourse/getAnnee");
    return response.data;
  }
);

// 2. Liste des demandes avec pagination
export const listDemandeAPI = createAsyncThunk(
  "bourse/listDemande",
  async ({ page = 0, size = 10 }) => {
    const url = `/api/bourse/getDemandes?page=${page}&size=${size}`;
    const response = await clientAPI.get(url);
    return response.data;
  }
);

// 3. Filtrage avec pagination
export const listBourseFilterAPI = createAsyncThunk(
  "bourse/listBourseFilter",
  async (data, thunkAPI) => {
    try {
      const page = data.page || 0;
      const size = data.size || 10;
      const filters = { ...data };
      delete filters.page;
      delete filters.size;

      const url = `/api/bourse/bourseFilter?page=${page}&size=${size}`;
      const response = await clientAPI.post(url, filters);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

// 4. Actions sur les demandes (Accepter, Traiter, Refuser, Incomplet)
export const attribueeBourseAPI = createAsyncThunk(
  "bourse/attribueeBourse",
  async ({ id }, thunkAPI) => {
    try {
      const response = await clientAPI.post(`/api/bourse/attribuee/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const traiteDemandeBourseAPI = createAsyncThunk(
  "bourse/traiteDemandeBourse",
  async ({ id }, thunkAPI) => {
    try {
      const response = await clientAPI.post(`/api/bourse/traiteDemande/${id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const refuserBourseAPI = createAsyncThunk(
  "bourse/refuserBourse",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus);
    const response = await clientAPI.post("/api/bourse/refusDemande", formData);
    return response.data;
  }
);

export const incompteteBourseAPI = createAsyncThunk(
  "bourse/incompteteBourse",
  async (data) => {
    const formData = new FormData();
    formData.append("idDemande", data.idDemande);
    formData.append("motifRefus", data.motifRefus); // Utilise le même champ que refus par convention
    const response = await clientAPI.post("/api/bourse/icompleteDemande", formData);
    return response.data;
  }
);

// 5. Gestion des fichiers
export const listTypeFichierSavedBourseAPI = createAsyncThunk(
  "bourse/listTypeFichierSaved",
  async (idDemande) => {
    const response = await clientAPI.get("/api/bourse/listeTypeFichierSaved/" + idDemande);
    return response.data;
  }
);

export const getFileByDemandeAndTypeBource = createAsyncThunk(
  "bourse/getFile",
  async (data) => {
    const response = await axios.get(
      `${SERVER_URL}/api/bourse/getFileByDemandeAndType/${data.idDemande}/${data.id_type_fichier}`,
      {
        headers: getAuthHeader(),
        responseType: "blob",
      }
    );
    // On retourne le blob pour que le composant puisse l'ouvrir
    return response.data;
  }
);

export const saveFichierImportAPI = createAsyncThunk(
  "bourse/saveFichierImportAPI",
  async (data) => {
    const fichi = JSON.stringify(data.toSave);

    const blob = new Blob([fichi], {
      type: "application/json",
    });

    var formData = new FormData();

    var theFile = data.file;

    formData.append("file", theFile);
    formData.append("fileMeta", blob);
    let token = localStorage.getItem("token");

    const response = axios.post(SERVER_URL + `/api/import/save_fileCarte`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      Accept: "application/json",
    });
    return (await response).data;
  }
);
export const saveFichierCompteAPI = createAsyncThunk(
  "bourse/saveFichierCompteAPI",
  async (data) => {
    const fichi = JSON.stringify(data.toSave);

    const blob = new Blob([fichi], {
      type: "application/json",
    });

    var formData = new FormData();

    var theFile = data.file;

    formData.append("file", theFile);
    formData.append("fileMeta", blob);
    let token = localStorage.getItem("token");

    const response = axios.post(SERVER_URL + `/api/import/save_file`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
      Accept: "application/json",
    });
    return (await response).data;
  }
);
export const saveDemandeBourseAPI = createAsyncThunk(
  "bourse/bourseSaveDemande",
  async (data) => {
    try {
      const response = await clientAPI.post("/api/bourse/bourseSaveDemande", data);
      return response.data;
    } catch (error) {
      return 'il est un probléme au niveau de la API';
    }
  }
);
export const listTypeFichierAPI = createAsyncThunk(
  "bourse/typeFichier",
  async (data) => {
    const url = `/api/bourse/getTypeFichier`;
    const response = await clientAPI.get(url);
    return response.data;
  }
);
export const confirmCompte = createAsyncThunk(
  "bourse/confirmCompte",
  async (data) => {
    const response = await clientAPI.post("/api/import/confirm",data);
    return response.data;
  }
);

// 6. Liste traitée et Export
export const listBourseDemandeTraiteAPI = createAsyncThunk(
  "bourse/listTraite",
  async () => {
    const response = await clientAPI.get("/api/bourse/listeDemandeTraite");
    return response.data;
  }
);

export const updateRibBourceAPI = createAsyncThunk(
  "soutient/updateRibBourceAPI",
  async (data, thunkAPI) => {
    try {


      // Construire l'URL avec les paramètres de pagination
      const url = `/api/bourse/updateRib`;

      const response = await clientAPI.post(url, data);
      return response.data;
    } catch (error) {
      console.error('Erreur API filtres:', error);
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const downloadExportBourseAPI = createAsyncThunk(
  "bourse/exportData",
  async (data) => {
    const token = localStorage.getItem("token");
    const d = new Date();
    const dateStr = d.toISOString().split('T')[0]; // Format simple YYYY-MM-DD

    const response = await axios.post(
      `${SERVER_URL}/api/bourse/export-data`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        responseType: "blob",
      }
    );

    fileDownload(response.data, `Export_Bourse_${dateStr}.xlsx`);
    return response.data;
  }
);

// --- SLICE ---

const BourseExcelenceSlice = createSlice({
  name: "bourseExcellence", // Doit correspondre à l'usage dans useSelector
  initialState: {
    listDemande: [],
    listeDemandeTraite: [],
    listBranche: [],
    listAnnee: [],
    listTypeFichierSaved: [],
    totalElements: 0,
    pageNumber: 0,
    pageSize: 0,
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Chargement
      .addCase(listDemandeAPI.pending, (state) => {
        state.status = "loading";
      })
      // Succès : Liste Standard
      .addCase(listDemandeAPI.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.listDemande = action.payload.content || [];
        state.totalElements = action.payload.totalElements || 0;
        state.pageNumber = action.payload.number || 0;
        state.pageSize = action.payload.size || 0;
      })
      // Succès : Filtre
      .addCase(listBourseFilterAPI.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.listDemande = action.payload.content || [];
        state.totalElements = action.payload.totalElements || 0;
        state.pageNumber = action.payload.number || 0;
        state.pageSize = action.payload.size || 0;
      })
      // Succès : Paramètres et Listes annexes
      .addCase(listBrancheAPI.fulfilled, (state, action) => {
        state.listBranche = action.payload;
      })
      .addCase(listAnneeAPI.fulfilled, (state, action) => {
        state.listAnnee = action.payload;
      })
      .addCase(listTypeFichierSavedBourseAPI.fulfilled, (state, action) => {
        state.listTypeFichierSaved = action.payload;
      })
      .addCase(listBourseDemandeTraiteAPI.fulfilled, (state, action) => {
        state.listeDemandeTraite = action.payload;
      })
      // Erreurs
      .addCase(listDemandeAPI.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(listBourseFilterAPI.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      });
  },
});

export default BourseExcelenceSlice.reducer;
